const frameInput = document.querySelector<HTMLInputElement>('input[data-asset-input="frame"]');

if (frameInput) {
  // Android WebView may route a media-only accept list to the system Photo Picker,
  // which hides QuickTime/ProRes MOV files completely. Request a generic file
  // instead; inspectAsset() still validates PNG/WebP/MOV after selection.
  frameInput.accept = '*/*';

  const card = frameInput.closest<HTMLElement>('.asset-card');
  const hint = card?.querySelector<HTMLElement>('small');
  if (hint) {
    hint.textContent =
      'Любой размер · автоматически обрежем по центру до 640×640 · PNG/WebP до 10 МБ, MOV до 50 МБ';

    const status = document.createElement('small');
    status.className = 'frame-normalization-status';
    status.hidden = true;
    hint.insertAdjacentElement('afterend', status);

    window.addEventListener('krug:frame-normalization', (event) => {
      const detail = (event as CustomEvent<{ state?: string; message?: string }>).detail;
      if (!detail?.message) {
        return;
      }
      status.hidden = false;
      status.textContent = detail.message;
      status.style.color = detail.state === 'error' ? 'var(--danger)' : '';
    });
  }
}
